import React from "react";
import { ColumnProps } from "types/models";
import dayjs from "dayjs";

const allColumns: ColumnProps[] = [
  {
    title: "STT",
    key: "index",
    show: true,
    dataIndex: "index",
    render(_, __, index) {
      return <>{index + 1}</>;
    },
    disabledCheck: true,
    align: "center",
    fixed: "left",
    width: 60,
    isResizable: true,
  },
  {
    title: "Từ ngày",
    key: "tu_ngay",
    show: true,
    dataIndex: "tu_ngay",
    width: 150,
    align: "center",
    isResizable: true,
    render: (v, r, idx) => (v !== null ? dayjs(v).format("DD/MM/YYYY") : null),
  },
  {
    title: "Phòng ban",
    key: "tenPhongBan",
    show: true,
    dataIndex: "tenPhongBan",
    width: 150,
    align: "center",
    isResizable: true,
  },
  {
    title: "Chức vụ",
    key: "tenChucVu",
    dataIndex: "tenChucVu",
    show: true,
    width: 100,
    align: "center",
    fixed: "right",
    isResizable: true,
  },
  {
    title: "Loại hợp đồng",
    key: "tenLoaiHopDong",
    dataIndex: "tenLoaiHopDong",
    show: true,
    width: 100,
    align: "center",
    fixed: "right",
    isResizable: true,
  },
];

export { allColumns };
